import { axiosWithRetry } from 'shared/api'

export const getGoogleApiValidation = async (
  postalCode: string,
  city: string,
  street: string,
  houseNumber: string
) => {
  const resp = await axiosWithRetry({
    url: `https://addressvalidation.googleapis.com/v1:validateAddress?key=${
      process.env.NEXT_PUBLIC_GOOGLE_API_KEY
    }`,
    method: 'POST',
    data: {
      address: {
        addressLines: [street, houseNumber, city, postalCode],
        regionCode: 'PL'
      }
    }
  })

  return resp
}
